import React, { useRef } from 'react'
import { useState } from 'react';

import { LogInSchoolID, YYYYMMDD, getTodayDate, getUrlParameter, isValidEmail, ymdToDate } from '../../JS/Common';

import { CheckValidation } from '../../Components/Validations';
import { useEffect } from 'react';
import { ApiGetCall, ApiPostCall } from '../../JS/Connector';
import { useContext } from 'react';
import { UserContext } from '../../App';
import AlertsComp from '../../Components/AlertsComp';
import { useLocation, useNavigate } from 'react-router-dom';
import { Dropdown, Form, OverlayTrigger, Popover } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faTimes } from '@fortawesome/free-solid-svg-icons';
import PageHead from '../../Components/PageHead';
import Popup from '../../Components/Popup';
import CustomReactDatePicker from '../../Components/CustomReactDatePicker';
import { RoleKey } from '../../JS/RoleType';
import useConfig from '../../Hooks/useConfig';

function AddSetup() {
    const { organization, student, students, adminCallNode, sm_dcc_text } = useConfig();
    const [AllData, setAllData] = useState({
        schoolName: '',
        contactName: '',
        contactEmail: '',
        planstatus: ''
    })
    const [planName, setPlanName] = useState('')
    const [PlanId, setPlanId] = useState('')
    const [EstimatedStudent, setEstimatedStudent] = useState('')
    const [PercentOfDevices, setPercentOfDevices] = useState('')
    const [takeDeviceHome, setTakeDeviceHome] = useState(false)
    const [AccessCode, setAccessCode] = useState('')
    const [CreatedDate, setCreatedDate] = useState('')
    const [EndDate, setEndDate] = useState('');
    const [CoverageEndDate, setCoverageEndDate] = useState('')
    const [DeviceModels, setDeviceModels] = useState('')
    const [Loading, setLoading] = useState(false);
    const [NewAlerts, setNewAlerts] = useState("");
    const [emailError, setEmailError] = useState("");
    const [GradeError, setGradeError] = useState("");
    const { UserData } = useContext(UserContext);
    const { role, copyrole } = UserData;
    const effectiveRole = copyrole || role;
    const loggedinemailid = UserData.emailid;
    const loggedinusername = UserData.UserName;
    const location = useLocation();
    const { state } = location;
    var planIdFromGrid = state && (state.isFromRenewClub ? 0 : state.id);
    const navigate = useNavigate();
    const currentDate = getTodayDate(new Date());
    const [AllGrades, setAllGrades] = useState([]);
    const [UserGrades, setUserGrades] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [showOthersInput, setShowOthersInput] = useState(false);
    const [customGrades, setCustomGrades] = useState('');
    const inputRef = useRef(null);
    const locationState = location.state;
    const fromPage = locationState && locationState.fromPage;
    const schoolId = locationState && locationState.schoolid;
    const isSignupEnded = new Date(currentDate) > new Date(EndDate);
    useEffect(() => {
        if (planIdFromGrid != 0) {
            setPlanId(planIdFromGrid)
            EditData(planIdFromGrid)
        } else {
            state.isFromRenewClub && EditData(state.id)
            setAllData({ ...AllData, schoolName: UserData.schoolname, contactName: loggedinusername, contactEmail: loggedinemailid })
            setCreatedDate(currentDate)
        }
        var schoolid = fromPage == 'admin' ? schoolId : LogInSchoolID
        ApiGetCall(`/plans/insurance/unused-grades?schoolId=${schoolid}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false)
                const responseRs = JSON.parse(result);
                setUserGrades(responseRs.length ? responseRs : [])
            }
        });
    }, []);

    const calculateEndDate = (startDate) => {
        const startYear = new Date(startDate).getFullYear();
        const endYear = startYear + 1;
        const endDate = `${endYear}-06-01`;
        return endDate;
    };
    useEffect(() => {
        if (CreatedDate) {
            if (planIdFromGrid == 0) {
                const calculatedEndDate = calculateEndDate(CreatedDate);
                setCoverageEndDate(calculatedEndDate);
            }
        }
    }, [CreatedDate]);


    async function EditData(planid) {
        setLoading(true);
        await ApiGetCall(`/plans/insurance/by-id?planId=${planid}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setAllData({
                    ...AllData, contactName: responseRs.contact_name, contactEmail: responseRs.contact_email, schoolName: responseRs.school_name,
                    planstatus: responseRs.status
                })
                !state.isFromRenewClub && setPlanId(planid)
                !state.isFromRenewClub && setPlanName(responseRs.plan_name)
                setAccessCode(responseRs.access_token)
                setEstimatedStudent(responseRs.estimated_enrollment)
                setPercentOfDevices(responseRs.devices_not_leave_school)
                setTakeDeviceHome(responseRs.keep_device_over_summer == 1 ? true : false)
                setDeviceModels(responseRs.device_models)
                setLoading(false);
                !state.isFromRenewClub && setCreatedDate(responseRs.start_date);
                !state.isFromRenewClub && setEndDate(responseRs.end_date);
                if (responseRs.coverage_end_date) {
                    !state.isFromRenewClub && setCoverageEndDate(responseRs.coverage_end_date);
                } else {
                    const calculatedEndDate = calculateEndDate(CreatedDate);
                    !state.isFromRenewClub && setCoverageEndDate(calculatedEndDate);
                }
                if (!state.isFromRenewClub) {
                    const updatedGrades = responseRs.grades.map(grade => ({ name: grade.name, planExpiredFlag: grade.plan_expired_flag, planId: grade.plan_id }));
                    setAllGrades(updatedGrades);
                }
            }
        });
    }
    async function CreateNewPlan(flag) {
        var isFormValid = CheckValidation({ formID: 'CreatePlanForm' });
        if (AllData.contactEmail == null) {
            AllData.contactEmail = "";
        }
        if (!isValidEmail(AllData.contactEmail)) {
            setEmailError('*Invalid Email')
            isFormValid = false;
        } else {
            setEmailError('')
        }
        if (AllGrades.length == 0) {
            setGradeError("*required");
            isFormValid = false;
        } else {
            setGradeError("")
        }
        if (!isFormValid) return;
        setLoading(true);
        var raw = JSON.stringify({
            schoolId: fromPage == 'admin' ? schoolId : LogInSchoolID,
            schoolName: AllData.schoolName,
            contactName: AllData.contactName,
            contactEmail: AllData.contactEmail,
            planName: planName,
            estimatedStudent: EstimatedStudent,
            percentOfDevices: PercentOfDevices,
            keepDeviceOverSummer: takeDeviceHome ? 1 : 0,
            deviceModels: DeviceModels,
            planId: PlanId ? PlanId : 0,
            startDate: CreatedDate,
            endDate: EndDate,
            coverageStartDate: CreatedDate,
            coverageEndDate: CoverageEndDate,
            grades: AllGrades,
            accessCode: AccessCode,
            planStatus: AllData.planstatus,
        });
        await ApiPostCall(`${adminCallNode}/plans/insurance/save`, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                if (result == "success") {
                    var msg = flag == 1 ? 'Club Created Successfully' : 'Club Updated Successfully';
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={msg} />)
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                        if (fromPage == 'admin') {
                            navigate('/pricing-activation-process');
                        }
                        else {
                            navigate('/setup');
                        }
                    }, 2000);
                }
                else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;
        const selectedOption = Object.values(UserGrades).find(opt => opt.name === value);

        if (checked) {
            setAllGrades(prev => {
                const updated = [
                    ...prev,
                    {
                        name: selectedOption.name,
                        planExpiredFlag: selectedOption.plan_expired_flag,
                        planId: selectedOption.grade_used_in_plan
                    }
                ];

                // Sorting
                updated.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));
                return updated;
            });
        } else {
            setAllGrades(prev =>
                prev.filter(item => item.name !== selectedOption.name)
            );
        }
    };


    const toggleDropdown = (isOpen) => {
        setShowDropdown(isOpen);
    };
    const toggleOthers = () => {
        setShowOthersInput(!showOthersInput);
        if (!showOthersInput) {
            setTimeout(() => {
                inputRef.current.focus();
            }, 100)
        }
    }
    const handleGrades = (e) => {
        setCustomGrades(e.target.value)
    }
    const addCustomGrade = () => {
        const trimmed = customGrades.trim().toUpperCase();
        if (!trimmed) return;

        const alreadyUsed = Object.values(UserGrades).find(
            option => option.name.toUpperCase() === trimmed && option.flag === 1
        );

        if (alreadyUsed) {
            setGradeError(`Grade '${trimmed}' is already used in previous clubs.`);
            return;
        }

        setGradeError('');

        // Check if it's already in AllGrades
        const existsInAllGrades = AllGrades.length && AllGrades?.some(g => g.name.toUpperCase() === trimmed);
        if (existsInAllGrades) {
            setCustomGrades('');
            inputRef.current.focus();
            return;
        }

        const updatedGrades = [...AllGrades, { name: trimmed, planExpiredFlag: 0 }];

        // Optional sort alphabetically by name
        updatedGrades.sort((a, b) => a.name.localeCompare(b.name));

        setAllGrades(updatedGrades);
        setCustomGrades('');
        inputRef.current?.focus();
    };

    const RemoveCustomGrades = (gradeName) => {
        const updated = AllGrades?.filter(g => g.name !== gradeName.name);
        setAllGrades(updated);
    };
    const [showStartDatePopover, setShowStartDatePopover] = useState(false);
    const [showEndDatePopover, setShowEndDatePopover] = useState(false);
    const StartPopover = (
        <Popover id="popover-start" style={{ maxWidth: '50%', fontSize: '14px' }} onMouseLeave={() => setShowStartDatePopover(false)}>
            <Popover.Body>
                <label>The date when sign-ups for {sm_dcc_text} begin.</label>
            </Popover.Body>
        </Popover>
    );
    const EndPopover = (
        <Popover id="popover-end" style={{ maxWidth: '50%', fontSize: '14px' }} onMouseLeave={() => setShowEndDatePopover(false)}>
            <Popover.Body>
                <label>The date when sign-ups for {sm_dcc_text} close.</label>
            </Popover.Body>
        </Popover>
    );
    const handleStartToggle = (nextShow) => {
        setShowStartDatePopover(nextShow);
    };
    const handleEndToggle = (nextShow) => {
        setShowEndDatePopover(nextShow);
    };
    const handleCancelClick = () => {
        if (fromPage == 'admin') {
            navigate('/pricing-activation-process');
        }
        else {
            navigate('/setup');
        }
    }
    const generateYears = () => {
        const years = [];
        const currentYear = new Date().getFullYear();
        for (let i = currentYear; i <= currentYear + 5; i++) {
            years.push(i.toString());
        }
        return years;
    };

    return (
        <>
            <PageHead heading={planIdFromGrid != 0 ? 'Edit Club' : 'Create Club'}
                loading={Loading} Alerts={NewAlerts} showsearch={false} />
            <div className='GridBox p-3'>
                <div className="col-12 ">
                    <div id='CreatePlanForm' className="parent">
                        <div className="row">
                            <div className='col-lg-8  px-4 my-1'>
                                <div className='greyBox row' style={{ height: "100%" }}>
                                    <div className='col-md-6 py-2'>
                                        <label className='fw-600 content-forsetupcards py-2'>Club Name <label className='redText'>*</label></label>
                                        <input type="text" maxLength={100} name='planName' className="form-control" autoComplete='off' required value={planName} onChange={(e) => { setPlanName(e.target.value) }} />
                                        <span className="form-text invalid-feedback">
                                            *required
                                        </span>
                                    </div>
                                    <div className='col-md-6  py-2'>
                                        <label className='fw-600 content-forsetupcards py-2'>Mid-Year Transfer Access Code <label className='redText'>*</label></label>
                                        <input type="text" maxLength={45} name='accesscode' className="form-control" autoComplete='off' required value={AccessCode} onChange={(e) => { setAccessCode(e.target.value) }} />
                                        <span className="form-text invalid-feedback">
                                            *required
                                        </span>
                                    </div>
                                    <div className='col-md-6 py-2'>
                                        <label className='fw-600 content-forsetupcards py-2'>Sign Up Start Date <label className='redText'>*</label></label>
                                        <OverlayTrigger
                                            trigger="click"
                                            placement="right"
                                            show={showStartDatePopover}
                                            onToggle={handleStartToggle}
                                            overlay={StartPopover}
                                        >
                                            <img src="/images/InfoBtn.svg" title="What is Sign Up Start Date?" className="cursor-pointer" height='12px' />
                                        </OverlayTrigger>

                                        <CustomReactDatePicker
                                            isRequired="true"
                                            selectedDate={CreatedDate ? ymdToDate(CreatedDate?.split(" ")[0]) : null}
                                            onChangeHandler={(date) => { setCreatedDate(date ? YYYYMMDD(date) : ""); }}
                                            minDate={ymdToDate(currentDate)}

                                            placeholderText="MM-DD-YYYY"
                                        />
                                        <span className="form-text invalid-feedback">
                                            *required
                                        </span>
                                    </div>
                                    <div className='col-md-6 py-2'>
                                        <label className='fw-600 content-forsetupcards py-2'>Sign Up End Date <label className='redText'>*</label></label>
                                        <OverlayTrigger
                                            trigger="click"
                                            placement="right"
                                            show={showEndDatePopover}
                                            onToggle={handleEndToggle}
                                            overlay={EndPopover}
                                        >
                                            <img src="/images/InfoBtn.svg" title="What is Sign Up End Date?" className="cursor-pointer" height='12px' />
                                        </OverlayTrigger>
                                        <CustomReactDatePicker
                                            isRequired="true"
                                            selectedDate={EndDate ? ymdToDate(EndDate?.split(" ")[0]) : null}
                                            onChangeHandler={(date) => { setEndDate(date ? YYYYMMDD(date) : ""); }}
                                            minDate={ymdToDate(currentDate)}
                                            placeholderText="MM-DD-YYYY"
                                        />
                                        <span className="form-text invalid-feedback">
                                            *required
                                        </span>
                                    </div>
                                    <div className="col-md-6 py-2">
                                        <label className='fw-600 content-forsetupcards py-2'>Club Start Date <label className='redText'>*</label></label>
                                        <CustomReactDatePicker selectedDate={CreatedDate ? ymdToDate(CreatedDate?.split(" ")[0]) : null} isDisabled={true} isReadOnly={true} />
                                    </div>
                                    {effectiveRole !== RoleKey.SCHOOL_ADMIN ? (
                                        <div className="col-md-6 py-2">
                                            <label className='fw-600 content-forsetupcards py-2'>Club End Date <label className='redText'>*</label></label>
                                            <CustomReactDatePicker
                                                isRequired="true"
                                                selectedDate={CoverageEndDate ? ymdToDate(CoverageEndDate?.split(" ")[0]) : null}
                                                onChangeHandler={(date) => { setCoverageEndDate(date ? YYYYMMDD(date) : ""); }}
                                                minDate={ymdToDate(currentDate)}
                                                placeholderText="MM-DD-YYYY"
                                                isDisabled={isSignupEnded}
                                            />
                                            <span className="form-text invalid-feedback">
                                                *required
                                            </span>
                                        </div>
                                    ) : (
                                        <div className="col-md-6 py-2">
                                            <label className='fw-600 content-forsetupcards py-2'>Club End Date <label className='redText'>*</label></label>
                                            <div className="d-flex align-items-center">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    //Sliced data bcz value from backend is something like "2027-05-31 20:00:00"
                                                    value={CoverageEndDate.slice(5, 10)}
                                                    readOnly
                                                    disabled
                                                    style={{ backgroundColor: '#f1f1f1', width: "110px" }}
                                                />
                                                <select
                                                    className="form-control"
                                                    value={CoverageEndDate.slice(0, 4)}
                                                    onChange={(e) => {
                                                        const newYear = e.target.value;
                                                        const monthDay = CoverageEndDate.slice(5); // MM-DD
                                                        setCoverageEndDate(`${newYear}-${monthDay}`);
                                                    }}
                                                    disabled={isSignupEnded}
                                                    style={isSignupEnded ? { backgroundColor: "#f1f1f1" } : {}}
                                                >
                                                    {generateYears().map((year) => (
                                                        <option key={year} value={year}>{year}</option>
                                                    ))}
                                                </select>


                                            </div>
                                        </div>
                                    )}


                                    <div className='col-md-6 py-2'>
                                        <label className='fw-600 content-forsetupcards py-2'>{organization} Contact Name <label className='redText'>*</label></label>
                                        <input type="text" maxLength={100} name='contactName' className="form-control" autoComplete='off' required value={AllData.contactName} onChange={(e) => { setAllData({ ...AllData, contactName: e.target.value }) }} />
                                        <span className="form-text invalid-feedback">
                                            *required
                                        </span>
                                    </div>
                                    <div className='col-md-6 py-2'>
                                        <label className='fw-600 content-forsetupcards py-2'>{organization} Contact Email <label className='redText'>*</label></label>
                                        <input type="text" maxLength={100} name='contactEmail' className="form-control" autoComplete='off' value={AllData.contactEmail} onChange={(e) => { setAllData({ ...AllData, contactEmail: e.target.value }) }} />
                                        <span className="Emailinvalid">
                                            {emailError}
                                        </span>
                                    </div>

                                    <div className='col-md-6  py-2'>
                                        <label className='fw-600 content-forsetupcards py-2'>Estimated {student} Enrollment <label className='redText'>*</label></label>
                                        <input type="number" name='Enrollment' className="form-control" min={0}
                                            autoComplete='off' required value={EstimatedStudent}
                                            onChange={(e) => { e.target.value != 0 && setEstimatedStudent(e.target.value) }}
                                            onKeyDown={(e) => {
                                                if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                    e.preventDefault();
                                                }
                                            }} />
                                        <span className="form-text invalid-feedback">
                                            *required
                                        </span>
                                    </div>
                                    <div className='col-md-6 py-2'>
                                        <label className='fw-600 content-forsetupcards py-2'>Device Models Included <label className='redText'>*</label></label>
                                        <textarea name='devicemodels' className="form-control" rows={1} required value={DeviceModels} onChange={(e) => { setDeviceModels(e.target.value) }} />
                                        <span className="form-text invalid-feedback">
                                            *required
                                        </span>
                                    </div>

                                    <div className='row py-2 align-items-center pe-0'>
                                        <div className='col-9 pe-0'>
                                            <label className='fw-600 content-forsetupcards py-2'>What Percentage of Devices go home with {students}? <label className='redText'>*</label></label>
                                        </div>
                                        <div className='col-3 px-0'>
                                            <div className="input-group d-flex">
                                                <input className="form-control" name='GoHomeWithStudents' autoComplete="off" required min={0} value={PercentOfDevices}
                                                    onChange={(e) => { setPercentOfDevices(e.target.value) }} type="number"
                                                    onKeyDown={(e) => {
                                                        if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                            e.preventDefault();
                                                        }
                                                    }} />
                                                <span className="input-group-text">%</span>
                                                <span className="form-text invalid-feedback">
                                                    *required
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row py-2 align-items-center pe-0'>

                                        <div className='col-12'>
                                            <div className="d-flex align-items-center">
                                                <input className='form-check-input cursor-pointer m-0' id="summerHomeCheck" checked={takeDeviceHome}
                                                    onChange={(e) => { setTakeDeviceHome(e.target.checked) }} type="checkbox"
                                                />
                                                <label htmlFor='summerHomeCheck' className='fw-600 content-forsetupcards ms-3 cursor-pointer'> {students} keep devices over summer?</label>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-4 px-4 my-1'>
                                <div className="py-3 row greyBox">
                                    <label className='redText'>* Previously used in an expired club.</label>
                                    <label className='fw-600 content-forsetupcards py-2'>Grades <label className='redText'>*</label></label>
                                    <Dropdown show={showDropdown} onToggle={toggleDropdown}>
                                        <Dropdown.Toggle style={{ backgroundColor: "white", color: "black", textAlign: 'left', width: "100%", border: "1px solid #e2e3e4", display: "flex", justifyContent: "space-between", alignItems: "center" }} onClick={() => setShowDropdown(!showDropdown)}>
                                            Select Grades
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu style={{ width: "100%" }}>
                                            <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                                {Object.entries(UserGrades).filter(([_, option]) => option?.name?.trim() != "").map(([key, option]) => (
                                                    <Dropdown.Item
                                                        key={option.name}
                                                        as="div"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();

                                                            if (
                                                                option.plan_expired_flag !== 1 &&
                                                                option.flag === 1
                                                            ) {
                                                                return;
                                                            }

                                                            handleCheckboxChange({
                                                                target: {
                                                                    value: option.name,
                                                                    checked: !AllGrades?.some(
                                                                        item => item.name === option.name
                                                                    )
                                                                }
                                                            });
                                                        }}
                                                    >
                                                        <div className="d-flex align-items-center gap-2">
                                                            <Form.Check
                                                                type="checkbox"
                                                                id={`checkbox-${option.name}`}
                                                                value={option.name}
                                                                disabled={
                                                                    option.plan_expired_flag !== 1 &&
                                                                    option.flag === 1
                                                                }
                                                                checked={AllGrades?.some(
                                                                    item => item.name === option.name
                                                                )}
                                                                readOnly
                                                            />

                                                            <span
                                                                style={{
                                                                    color:
                                                                        option.plan_expired_flag === 1
                                                                            ? "red"
                                                                            : "inherit",
                                                                    opacity: option.plan_expired_flag !== 1 &&
                                                                        option.flag === 1 ? 0.5 : 1
                                                                }}
                                                            >
                                                                {option.name}
                                                            </span>
                                                        </div>
                                                    </Dropdown.Item>

                                                ))}
                                                <Dropdown.Item onClick={toggleOthers}>
                                                    <Form.Check type="checkbox" id="checkbox-others" label="Others"
                                                        checked={showOthersInput} onChange={toggleOthers} />
                                                </Dropdown.Item>
                                            </div>
                                        </Dropdown.Menu>
                                    </Dropdown>

                                    <div className='col-12 p-3'>
                                        {showOthersInput && (
                                            <div className="row">
                                                <div className='col-md-10'>
                                                    <input type="text" className='form-control' placeholder='Enter Grade' value={customGrades} onChange={handleGrades} ref={inputRef} />
                                                </div>
                                                <div className="col-md-2">
                                                    <label className='BorderBtn' style={{ marginRight: '0', padding: '2px 8px 2px 8px' }} onClick={addCustomGrade} ><img src="/images/helpdeskcategoryadd.svg" alt="" style={{ height: "25px" }} /></label>
                                                </div>
                                            </div>
                                        )}

                                        {AllGrades?.length > 0 && AllGrades?.map((option) => (
                                            <span key={option.name} className="badge bg-secondary me-2 mt-2">
                                                {option.name}
                                                <span>
                                                    <FontAwesomeIcon icon={faTimes} className="cursor-pointer" title="Remove Grade" style={{ marginLeft: '5px' }} onClick={() => RemoveCustomGrades(option)} />
                                                </span>

                                            </span>
                                        ))}
                                    </div>
                                    <span className="Emailinvalid">
                                        {GradeError}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    {fromPage == 'admin' &&
                        <div className='mt-3 text-center'>
                            <span><FontAwesomeIcon icon={faExclamationTriangle} style={{ color: "red", height: "100px", height: '18px' }} className="img-fluid" /></span>
                            <span className="ps-2 redText">Editing this club will affect all currently active users associated with it. Please review changes carefully.</span>
                        </div>
                    }
                    <div className='pt-3 text-center'>
                        {planIdFromGrid != 0 ?
                            <button className='SaveBtn' onClick={(e) => CreateNewPlan(2)}>Update Club</button>
                            :
                            <button className='SaveBtn' onClick={(e) => CreateNewPlan(1)}>Create Club</button>
                        }
                        <label className="mx-2 cursor-pointer" onClick={handleCancelClick}><u>Cancel</u></label>
                    </div>
                </div>
            </div >
        </>
    )
}

export default AddSetup
